"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTicketCheckInMethod = exports.ProductTicketStatus = void 0;
var ProductTicketStatus;
(function (ProductTicketStatus) {
    ProductTicketStatus["Pending"] = "pending";
    // the transaction is pending validation.
    ProductTicketStatus["Active"] = "active";
    ProductTicketStatus["Canceled"] = "canceled";
    ProductTicketStatus["CheckedIn"] = "checked-in";
})(ProductTicketStatus || (exports.ProductTicketStatus = ProductTicketStatus = {}));
var ProductTicketCheckInMethod;
(function (ProductTicketCheckInMethod) {
    ProductTicketCheckInMethod["ManualWeb"] = "manual_web";
    ProductTicketCheckInMethod["QrScanWeb"] = "qr_scan_web";
    ProductTicketCheckInMethod["ManualApp"] = "manual_app";
    ProductTicketCheckInMethod["QrScanApp"] = "qr_scan_app";
    ProductTicketCheckInMethod["DoorSaleApp"] = "door_sale_app";
})(ProductTicketCheckInMethod || (exports.ProductTicketCheckInMethod = ProductTicketCheckInMethod = {}));
